var chunkMapping = {
	"webpack_container_remote_COM_InitSocket": [
		"webpack/container/remote/COM/InitSocket"
	],
	"webpack_container_remote_COM_Shared": [
		"webpack/container/remote/COM/Shared"
	],
	"webpack_container_remote_HRM_App": [
		"webpack/container/remote/HRM/App"
	],
	"webpack_container_remote_AST_App": [
		"webpack/container/remote/AST/App"
	],
	"webpack_container_remote_SLR_App": [
		"webpack/container/remote/SLR/App"
	],
	"webpack_container_remote_RCM_App": [
		"webpack/container/remote/RCM/App"
	],
	"webpack_container_remote_PER_App": [
		"webpack/container/remote/PER/App"
	],
	"webpack_container_remote_TRAIN_App": [
		"webpack/container/remote/TRAIN/App"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/COM/InitSocket": [
		"default",
		"./InitSocket",
		"webpack/container/reference/COM"
	],
	"webpack/container/remote/COM/Shared": [
		"default",
		"./Shared",
		"webpack/container/reference/COM"
	],
	"webpack/container/remote/HRM/App": [
		"default",
		"./App",
		"webpack/container/reference/HRM"
	],
	"webpack/container/remote/AST/App": [
		"default",
		"./App",
		"webpack/container/reference/AST"
	],
	"webpack/container/remote/SLR/App": [
		"default",
		"./App",
		"webpack/container/reference/SLR"
	],
	"webpack/container/remote/RCM/App": [
		"default",
		"./App",
		"webpack/container/reference/RCM"
	],
	"webpack/container/remote/PER/App": [
		"default",
		"./App",
		"webpack/container/reference/PER"
	],
	"webpack/container/remote/TRAIN/App": [
		"default",
		"./App",
		"webpack/container/reference/TRAIN"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}